import { doDELETE, doGET, doPOST, doPUT } from '../../utils/HttpUtils';

export type EmailKind = 'onboarding' | 'event_registration';
export type EmailEventType = 'AHC' | 'PEHC' | 'CAMP';
export type EmailScope = 'default' | 'corporate' | 'event';
export interface TemplateContext { kind: EmailKind; scope: EmailScope; corporateId?: string; eventId?: string; eventType?: EmailEventType; }
export interface TemplateContent { subject: string; html: string; }
export interface SavedTemplate extends TemplateContent { _id: string; isActive: boolean; __v: number; }
export interface TemplateResult { template: SavedTemplate | null; effective: TemplateContent; inheritedFrom: string; placeholders: string[]; }
export interface EmailPreview { subject: string; htmlBody: string; textBody: string; changedBySanitizer: boolean; }
export interface TemplateOption { _id: string; name: string; companyName?: string; }
const base = '/email-templates';
function unwrap<T>(response: any): T {
  if (!response || response.error || response.status >= 400) throw Object.assign(new Error(response?.message || 'Email template request failed.'), { status: response?.status });
  return response.data?.data ?? response.data;
}
export const emailTemplateApi = {
  async get(context: TemplateContext): Promise<TemplateResult> {
    return unwrap(await doGET(`${base}?${new URLSearchParams(context as unknown as Record<string, string>)}`));
  },
  async save(context: TemplateContext, content: TemplateContent, isActive: boolean, expectedVersion: number | null, templateId?: string) {
    return unwrap<{ template: SavedTemplate; changedBySanitizer: boolean }>(await doPUT(base, { ...context, ...content, isActive, expectedVersion, ...(templateId ? { templateId } : {}) }));
  },
  async preview(context: TemplateContext, content: TemplateContent): Promise<EmailPreview> {
    return unwrap(await doPOST(`${base}/preview`, { ...context, ...content }));
  },
  async sendDemo(context: TemplateContext, content: TemplateContent): Promise<{ recipients: string[] }> {
    return unwrap(await doPOST(`${base}/send-demo`, { ...context, ...content }));
  },
  async remove(id: string) { return unwrap(await doDELETE(`${base}/${id}`)); },
  async corporates(): Promise<TemplateOption[]> { return unwrap(await doGET('/corporates')); },
};
